var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoSchedule = function SvgNoSchedule(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icone_Agenda",
    "data-name": "Icone Agenda",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2220",
    "data-name": "Caminho 2220",
    d: "M32.751,24.192H22.126V34.734H32.751ZM30.626,1V5.217h-17V1H9.375V5.217H7.25A4.214,4.214,0,0,0,3.021,9.434L3,38.951a4.232,4.232,0,0,0,4.25,4.217H37a4.246,4.246,0,0,0,4.25-4.217V9.434A4.246,4.246,0,0,0,37,5.217H34.876V1ZM37,38.951H7.25V15.759H37Z",
    transform: "translate(2.874 2.916)",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2221",
    "data-name": "Caminho 2221",
    d: "M0,0H50V50H0Z",
    fill: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoSchedule, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-schedule.88e9cd8f.svg";
export { ForwardRef as ReactComponent };